export default __webpack_public_path__ + "static/media/logo.235d00e1.svg";